var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import createStyle from './createStyle';
import icons from './icons';
export var sizes = {
  xs: '13px',
  s: '17px',
  m: '20px',
  l: '30px',
  xl: '48px',
  xxl: '64px'
};
export var Icon = function Icon(_a) {
  var name = _a.name,
      _b = _a.rotation,
      rotation = _b === void 0 ? 0 : _b,
      _c = _a.size,
      size = _c === void 0 ? 'm' : _c,
      _d = _a.width,
      width = _d === void 0 ? '' : _d,
      _e = _a.height,
      height = _e === void 0 ? '' : _e,
      _f = _a.className,
      className = _f === void 0 ? '' : _f,
      _g = _a.fill,
      fill = _g === void 0 ? 'currentColor' : _g,
      props = __rest(_a, ["name", "rotation", "size", "width", "height", "className", "fill"]);

  var finalClassName = createStyle({
    className: className,
    fill: fill,
    rotation: rotation,
    size: sizes[size],
    height: height || sizes[size],
    width: width || sizes[size]
  });
  var _h = icons[name],
      viewbox = _h.viewbox,
      path = _h.path;
  return React.createElement("svg", __assign({
    className: finalClassName,
    viewBox: viewbox
  }, props), path);
};
export default Icon;